import request from '@/utils/request'


// 查询分销商奖励列表
export function listDistributorReward(query) {
  return request({
    url: '/user/user-distributor-rewards/list',
    method: 'get',
    params: query
  })
}

// 查询分销商奖励分页
export function pageDistributorReward(query) {
  return request({
    url: '/user/user-distributor-rewards/page',
    method: 'get',
    params: query
  })
}

// 查询分销商奖励详细
export function getDistributorReward(data) {
  return request({
    url: '/user/user-distributor-rewards/detail',
    method: 'get',
    params: data
  })
}

// 新增分销商奖励
export function addDistributorReward(data) {
  return request({
    url: '/user/user-distributor-rewards/add',
    method: 'post',
    data: data
  })
}

// 修改分销商奖励
export function updateDistributorReward(data) {
  return request({
    url: '/user/user-distributor-rewards/edit',
    method: 'post',
    data: data
  })
}

// 删除分销商奖励
export function delDistributorReward(data) {
  return request({
    url: '/user/user-distributor-rewards/delete',
    method: 'post',
    data: data
  })
}
